module.exports = __webpack_public_path__ + "static/media/illu1.67ca8c76.png";